import { ReactComponent as Settings } from "../../../../assets/icons/large/settings.svg";
import { ReactComponent as Calendar } from "../../../../assets/icons/large/calendar.svg";
import { ReactComponent as Send } from "../../../../assets/icons/large/send.svg";
import { ReactComponent as Computer } from "../../../../assets/icons/large/computer.svg";
import { ReactComponent as Sparkle } from "../../../../assets/icons/large/sparkle.svg";
import { ReactComponent as Hide } from "../../../../assets/icons/large/hide.svg";
import { ReactComponent as Check } from "../../../../assets/icons/large/check.svg";
import { ReactComponent as LeadingIcon } from "../../../../assets/icons/large/leadingIcon.svg";
import { ReactComponent as Seperator } from "../../../../assets/icons/large/seperator.svg";
import { ReactComponent as MobileMenu } from "../../../../assets/icons/large/mobileMenu.svg";

import * as types from "./types";

export const icon2iconUrl: Record<types.IconTypes, React.ReactElement> = {
  LEADINGICON: <LeadingIcon />,
  SETTINGS: <Settings />,
  CALENDAR: <Calendar />,
  SEND: <Send />,
  COMPUTER: <Computer />,
  SPARKLE: <Sparkle />,
  HIDE: <Hide />,
  CHECK: <Check />,
  SEPERATOR: <Seperator />,
  MOBILEMENU: <MobileMenu />,
};
